import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Icomoon__lock",
  "use": "Icomoon__lock-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"Icomoon__lock\"><path d=\"M296 224h-8v-96c0-52.935-43.065-96-96-96h-64c-52.935 0-96 43.065-96 96v96h-8c-13.2 0-24 10.8-24 24v240c0 13.2 10.8 24 24 24h272c13.2 0 24-10.8 24-24V248c0-13.2-10.8-24-24-24zM96 128c0-17.645 14.355-32 32-32h64c17.645 0 32 14.355 32 32v96H96v-96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol